await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-js-components-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const DRAG_DATA_DEFINITION_FIELD_ADD = 'dataDefinitionField:add';
export const DRAG_FIELD_TYPE_ADD = 'fieldType:add';
export const DRAG_FIELD_TYPE_MOVE = 'fieldType:move';
export const DRAG_FIELDSET_ADD = 'fieldset:add';
